/**
 * useLocationInvoiceEnabled Hook (BLU-328)
 *
 * Reads the per-location invoice_enabled setting.
 * Returns false while loading to prevent flash of invoice UI.
 * Server default is true (opt-out design) — invoices are available unless explicitly disabled.
 */

import { trpc } from '@/lib/trpc';

export function useLocationInvoiceEnabled(locationId: string | undefined): boolean {
  const { data, isLoading } = trpc.productionSettings.getLocationInvoiceEnabled.useQuery(
    { locationId: locationId! },
    { enabled: !!locationId, staleTime: 60 * 1000 }
  );

  // Return false while loading to prevent flash of invoice UI elements.
  // Once loaded, the server-side default (true) takes effect for new locations.
  if (isLoading || !data) return false;
  return data.enabled;
}
